import React from 'react'

function Productlst2() {
  return (
    <div>Productlst2</div>
  )
}

export default Productlst2